import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Form, Grid, Header, Segment, Image } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import { setUserCredentials } from '../api/authentication-utils'
import logo from '../assets/jason.png'

function LoginForm ({ setAuthLoading }) {
  const history = useHistory()
  const [username, setUsename] = useState('')
  const [password, setPassword] = useState('')

  const handleSubmit = () => {
    setUserCredentials(username, password)
    setAuthLoading(true)
    history.push('/')
  }
  return (
    <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
      <Grid.Column style={{ maxWidth: 450 }}>
        <Header as='h1' color='black' textAlign='center'>
          Welcome to mechanic!
        </Header>
        <Image
          src={logo} size='small' centered
        />
        <Form onSubmit={handleSubmit} action size='large'>
          <Segment stacked>
            <Form.Input
              fluid icon='user' iconPosition='left' placeholder='Username'
              onChange={e => setUsename(e.target.value)}
            />
            <Form.Input
              fluid
              icon='lock'
              iconPosition='left'
              placeholder='Password'
              type='password'
              onChange={e => setPassword(e.target.value)}
            />
            <Button color='black' fluid size='large'>
              Login
            </Button>
          </Segment>
        </Form>
      </Grid.Column>
    </Grid>
  )
}

LoginForm.propTypes = {
  setAuthLoading: PropTypes.bool
}

export default LoginForm
